import React from "react";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { PageSection, PageSectionProps } from "../../../designSystem/PageSection";
import { PageSectionVariant } from '../../../designSystem/PageSectionDefs';
import { DesignSystemPageSection } from "./DesignSystemPageSection";
import { PageSectionTabs } from "../../../designSystem/PageSectionTabs";


type PageSectionExample = {
    label:string
} & Omit<PageSectionProps, 'headerStyleVariant' | 'contentStyleVariant'>;


const selectedExamples:PageSectionExample[] = [
    {
        label: 'Everything all at once',
        header:{ 
            title:'Header title', 
            subTitle: { 
                text: 'Header subtitle', 
                icon: 'clock', 
                iconColor: '#f00' 
            }, 
            avatar: { 
                text: 'AB' 
            }, 
            headerVariant: 'H3', 
            button: { variant: 'filled', text: 'Click me', onClick: () => alert('Button clicked') }, 
            popupMenuButton: {
                buttonVariant: 'text',
                entries: [
                    { type: 'menuItem', text: 'Menu item 1', onClick: () => alert('Menu item 1 clicked') },
                    { type: 'menuItem', text: 'Menu item 2', onClick: () => alert('Menu item 2 clicked') },
                ],
            }, 
            defaultCollapsed: false 
        },
    }
]


const otherExamples:PageSectionExample[] = [
    { 
        label: 'no header', 
        header: undefined,
    },
    
    {
        label: 'With icon', 
        header: { title: 'Header title', icon: 'calendar' },
    },
    {
        label: 'With subtitle',
        header:{ title:'Header title', subTitle:{ text: 'Header subtitle' } } 
    },
    {
        label: 'With subtitle icon and color',
        header:{ title:'Header title', subTitle: { text: 'Header subtitle', icon: 'clock', iconColor: '#f00' } },
    },
    {
        label: 'With avatar',
        header:{ title:'Header title', avatar: { text: 'AB' } },
    },
    {
        label: 'As H3',
        header:{ title:'Header title', headerVariant: 'H3' },
    },
    {
        label: 'As H4',
        header:{ title:'Header title', headerVariant: 'H4' },
    },
    {
        label: 'With button',
        header:{ title:'Header title', button: { variant: 'filled', text: 'Click me', onClick: () => alert('Button clicked') } },
    },
    {
        label: 'With popup menu',
        header:{ title:'Header title', popupMenuButton: {
            buttonVariant: 'text',
            entries: [
                { type: 'menuItem', text: 'Menu item 1', onClick: () => alert('Menu item 1 clicked') },
                { type: 'menuItem', text: 'Menu item 2', onClick: () => alert('Menu item 2 clicked') },
            ],
        } },
    },
    {
        label: 'Collapsible',
        header:{ title:'Header title', defaultCollapsed: false },
    },
    {
        label: 'Collapsed by default',
        header:{ title:'Header title', defaultCollapsed: true },
    }
];

const variants:PageSectionVariant[] = ['card', 'minimal'];

export const PageSectionOverview = (): JSX.Element => 
{

    return (
        <div>
            <DesignSystemPageSection title={'PageSectionTabs'}>
                <PageSectionTabs
                    header={{
                        tabberProps: {
                            items: [
                                { text: 'Tab 1', tabName: 'content 1' },
                                { text: 'Tab 2', tabName: 'content 2' },
                            ]
                        },
                    }}>

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                </PageSectionTabs>
            </DesignSystemPageSection>

            <DesignSystemPageSection title={'Selected examples'}>
                <Flex flexDirection="column">
                    {[...variants].map((vHeader,iHeader) =>

                        [...variants].map((vContent,iContent) =>

                            selectedExamples.map((styleExample, iStyleExample) => {

                                const key = `${iHeader}-${iContent}-${iStyleExample}`;
                                return (
                                    <React.Fragment key={key}>
                                        {renderProps({ ...styleExample, headerStyleVariant: vHeader, contentStyleVariant: vContent, label: styleExample.label })}
                                    </React.Fragment>
                                );
                            })
                        )
                    )}
                </Flex>
            </DesignSystemPageSection>

            <DesignSystemPageSection title={'All variations'}>
                <Flex flexDirection="column">
                    {[...variants].map((vHeader,iHeader) =>

                        [...variants].map((vContent,iContent) =>

                            otherExamples.map((styleExample, iStyleExample) => {

                                const key = `${iHeader}-${iContent}-${iStyleExample}`;
                                return (
                                    <React.Fragment key={key}>
                                        {renderProps({ ...styleExample, headerStyleVariant: vHeader, contentStyleVariant: vContent, label: styleExample.label })}
                                    </React.Fragment>
                                );
                            })
                        )
                    )}
                </Flex>
            </DesignSystemPageSection>
        </div>
    );
}

function renderProps(props:PageSectionProps & {label:string}): JSX.Element {
    
    const label = `header: ${props.headerStyleVariant || 'undefined'}, content: ${props.contentStyleVariant || 'undefined'} - ${props.label}`;
    const pageSectionProps = {
        ...props,
        header: {
            ...props.header,
            title: label
        }
    };

    return (
        <div style={{border:'1px dotted #000', padding:'20px'}}>
            <PageSection {...pageSectionProps}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </PageSection>
        </div>
    );
}